import React from 'react'

function J02() {
  return (
    <div>J02</div>
  )
}

export default J02